// 📁 src/contexts/AuthContext.js

import { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [client, setClient] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  // Toujours lire le localStorage une fois au montage
  useEffect(() => {
    console.log("AuthContext: Initialisation...");
    const savedClient = localStorage.getItem("client");
    const savedToken = localStorage.getItem("authToken");
    
    console.log("AuthContext: savedClient existe:", !!savedClient);
    console.log("AuthContext: savedToken existe:", !!savedToken);
    
    if (savedClient && savedToken) {
      try {
        const parsedClient = JSON.parse(savedClient);
        console.log("AuthContext: Client restauré:", parsedClient.email, "Rôle:", parsedClient.role);
        setClient(parsedClient);
      } catch (error) {
        console.error("Erreur lors du parsing des données client:", error);
        // En cas d'erreur, nettoyer le localStorage
        localStorage.removeItem("client");
        localStorage.removeItem("authToken");
      }
    } else {
      console.log("AuthContext: Aucune session sauvegardée trouvée");
    }
    
    console.log("AuthContext: Chargement terminé");
    setIsLoading(false);
  }, []);

  const login = (clientData, token) => {
    console.log("AuthContext: Connexion utilisateur:", clientData.email, "Rôle:", clientData.role);
    setClient(clientData);
    localStorage.setItem("client", JSON.stringify(clientData));
    localStorage.setItem("authToken", token);
  };

  const logout = () => {
    console.log("AuthContext: Déconnexion utilisateur");
    setClient(null);
    localStorage.removeItem("client");
    localStorage.removeItem("authToken");
  };

  // Fonction utilitaire pour vérifier si l'utilisateur a un rôle spécifique
  const hasRole = (role) => {
    return client && client.role === role;
  };

  // Fonction pour vérifier si l'utilisateur est authentifié
  const isAuthenticated = () => {
    return !!client;
  };

  // Fonction pour obtenir le token
  const getToken = () => {
    return localStorage.getItem("authToken");
  };

  return (
    <AuthContext.Provider value={{ 
      client, 
      isLoading,
      login, 
      logout, 
      hasRole, 
      isAuthenticated,
      getToken
    }}>
      {children}
    </AuthContext.Provider>
  );
};

